
export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative pt-32 pb-24 px-6 lg:px-8 overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A1628] via-[#0F1F3A] to-[#0A1628]"></div>
      
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-96 h-96 bg-[#0EA5E9] rounded-full filter blur-[120px]"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#06B6D4] rounded-full filter blur-[120px]"></div>
      </div>

      <div className="relative max-w-5xl mx-auto text-center">
        <div className="inline-flex items-center space-x-2 bg-emerald-500/10 border border-emerald-500/30 rounded-full px-5 py-2 mb-8">
          <div className="w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
          <span className="text-emerald-400 font-semibold text-sm tracking-wide uppercase">
            LIVE • BUILT • DEPLOYABLE
          </span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-8">
          <span className="text-[#0EA5E9]">AiConnect</span>
          <span className="text-gray-400 text-2xl md:text-3xl lg:text-4xl font-medium block mt-3 tracking-wide"> by Daily Nest Group, LLC</span>
        </h1>

        <p className="text-xl md:text-2xl text-gray-300 leading-relaxed mb-12 max-w-4xl mx-auto">
          AiConnect is a fully operational AI front-office infrastructure that answers, qualifies, and books appointments 24/7. This raise accelerates distribution and recurring revenue growth — not product development.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('live-demos')}
            className="bg-[#0EA5E9] hover:bg-[#0284C7] text-white px-8 py-4 rounded-lg font-bold text-lg transition-all shadow-lg shadow-[#0EA5E9]/30 cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            View Live Demos
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className="bg-white/5 hover:bg-white/10 text-white border border-white/20 px-8 py-4 rounded-lg font-bold text-lg transition-all cursor-pointer whitespace-nowrap w-full sm:w-auto"
          >
            Request Investor Brief
          </button>
        </div>
      </div>
    </section>
  );
}
